import type { components } from "@dolfin/api-admin";
import { InvoicesTable } from "@/components/InvoicesTable";
import { RecordListFilterBar, useRecordListFilters } from "@/components/RecordListFilters";

type InvoiceState = components["schemas"]["InvoiceState"];

// The Record type makes this exhaustive: a new InvoiceState is a compile error.
const STATE_LABELS: Record<InvoiceState, string> = {
  Draft: "Draft",
  Issued: "Issued",
  PartiallyPaid: "Partially paid",
  Paid: "Paid",
  Credited: "Credited",
  Void: "Void",
};

export function InvoicesPage() {
  const { values, bar } = useRecordListFilters({ states: STATE_LABELS, textParam: "invoiceNumber" });

  return (
    <div className="mx-auto w-full max-w-[100rem] p-8">
      <h1 className="mb-1 text-2xl font-bold">Invoices</h1>
      <p className="mb-6 text-sm text-muted-foreground">Invoices across all organisations, newest first.</p>

      <RecordListFilterBar filters={bar} textPlaceholder="Filter by invoice number..." dateLabel="Issued" />

      <InvoicesTable
        organisationId={values.organisationId}
        filters={{
          states: values.state ? [values.state] : undefined,
          invoiceNumber: values.text,
          issueDateFrom: values.from,
          issueDateTo: values.to,
        }}
      />
    </div>
  );
}
